<template>
    <div class="btmMsg" :style="key === '/home' ? 'background:#fff' : 'background:#f5f4f8'">
        <div class="banner" v-if="isBanner">
            <img src="@/assets/layout/banner.png" alt="">
        </div>
        <div class="msg">
            <div class="list">
                <div class="title">新手帮助</div>
                <div class="cont">院校优先填报</div>
                <div class="cont">职业优先填报问题</div>
                <div class="cont">茗硕择嘉大数据</div>
            </div>
            <div class="list">
                <div class="title">常见问题</div>
                <div class="cont">测评选专业</div>
                <div class="cont">志愿筛选</div>
                <div class="cont">志愿排序与审核</div>
                <div class="cont">专家服务</div>
            </div>
            <div class="list">
                <div class="title">联系我们</div>
                <div class="cont">133-6383-8216</div>
                <div class="cont">石家庄市裕华东路河北科技</div>
                <div class="cont">大学中校区</div>
                <div class="cont">1139977116@qq.com</div>
            </div>
            <div class="list">
                <div class="title">官方声明</div>
                <div class="cont">意见反馈</div>
                <div class="cont">用户协议</div>
                <div class="cont">VIP权限说明</div>
            </div>
            <div class="list ewm">
                <img src="@/assets/layout/gzh.png" alt=""/>
                <div class="ewm">茗硕择嘉公众号</div>
            </div>
            <div class="list ewm">
                <img src="@/assets/layout/xcx.png" alt=""/>
                <div class="ewm">茗硕择嘉小程序</div>
            </div>
        </div>
        <div class="forTheRecord">
            Copyright @ 2011-2023 茗硕择嘉（河北）教育科技有限公司All Rights Reserved.
            版权所有备案号：冀ICP备20012958号
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isBanner: true
        }
    },
    computed: {
        key() {
            let arr = ['/profession', '/subject', '/subject-analyse', '/subject']
            this.isBanner = arr.indexOf(this.$route.path) == -1
            return this.$route.path
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/style/var.scss";

.btmMsg {
    width: 100%;
    
    .msg {
        //width: calc(100% - $width-pdTotal);
    width: 1230px;;
        padding: 0 $width-padding;
        height: 310px;
        display: flex;
        font-size: 18px;
        justify-content: space-between;
        background: #eeeeee;
        color: var(--font-3);
        
        .list {
            padding-top: 50px;
            display: flex;
            flex-direction: column;
            
            .title {
                color: var(--font-1);
                font-weight: 500;
                margin-bottom: 5px;
            }
            
            .cont {
                margin-top: 15px;
                cursor: pointer;
            }
        }
        
        .ewm {
            font-size: 14px;
            color: var(--font-1);
            align-items: center;
            
            img {
                width: 110px;
                height: 110px;
                margin-bottom: 15px;
            }
        }
    }
    
    .forTheRecord {
        //width: calc(100% - $width-pdTotal);
    width: 1230px;;
        padding: 0 $width-padding;
        text-align: center;
        line-height: 69px;
        height: 69px;
        background: linear-gradient(90.08deg, #e93a29 1.09%, #ef6830 98.67%);
        font-size: 18px;
        color: #ffc0b7;
    }
    
    .banner {
        //width: calc(100% - $width-pdTotal);
    width: 1230px;;
        padding: 0 $width-padding;
        margin-bottom: 40px;
        
        img {
            width: 100%;
            height: 208px;
        }
    }
}
</style>